import React from 'react';

import GLOBALS from 'app-globals';
import { Container, Heading } from 'components';
import { HEADING_SIZES, HEADING_WEIGHTS } from 'components/Heading/constants';

import * as styles from './styles.module.scss';

function PageWrapper({ children, image, title, subtitle }) {
  return (
    <>
      <div className={styles.head}>
        <Container>
          <div className={styles.header}>
            {subtitle && (
              <Heading
                className={styles.subtitle}
                colorClass={GLOBALS.COLOR_CLASSES.BLUE['300']}
                size={HEADING_SIZES.XXXS}
                weight={HEADING_WEIGHTS.SEMIBOLD}
              >
                {subtitle}
              </Heading>
            )}
            <Heading className={styles.title} size={HEADING_SIZES.LG}>
              {title}
            </Heading>
          </div>
        </Container>
        {image}
      </div>
      <div className={styles.content}>{children}</div>
    </>
  );
}

export default PageWrapper;
